import classNames from 'classnames';
import { FieldsList, FieldWrapper } from 'components/common-form/builder/form/node/block/FieldsList';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import type { ProductNode } from 'state/product-description/model';

import type { MainFormSkeletonProps } from './MainFormSkeleton.connect';
import { connectMainSkeletonForm } from './MainFormSkeleton.connect';
import { TopBarSkeleton } from './TopBarSkeleton';

const BlockSkeleton: FC<{ node: ProductNode }> = ({ node: { id, direction, children, width: blockWidth } }) => (
  <div className="block w-100" id={id}>
    <div className="card bg-lvl1 h-100 shadow-sm">
      <div className="card-header">
        <h5 className="card-title">
          <Skeleton width="20em" />
        </h5>
      </div>
      <div className="card-body">
        <div className="card-text">
          <FieldsList
            nodes={children}
            direction={direction ?? 'leftToRight'}
            blockWidth={blockWidth ?? 'full'}
            renderChild={node => (
              <FieldWrapper key={node.id} width={node.width ?? blockWidth ?? 'full'}>
                <FieldSkeleton id={node.id} type={node.type} />
              </FieldWrapper>
            )}
          />
        </div>
      </div>
    </div>
  </div>
);

const FieldSkeleton: FC<{ id: string; type: string | undefined }> = ({ id, type }) => {
  if (type === 'Blank') {
    return null;
  }
  return (
    <div className="form-group py-2">
      <label htmlFor={id} className="col-form-label">
        <Skeleton width="10em" />
      </label>
      <input type="text" id={id} className="form-control" />
    </div>
  );
};

export const Component: FC<MainFormSkeletonProps> = ({ productDescription, product, isInternalUser }) => {
  return (
    <>
      <TopBarSkeleton isInternal={isInternalUser} />
      <div
        className={classNames('px-2 pt-1 mt-1 pb-2 bg-lvl3  static-form__css-grid view-default')}
        data-product={product}
        data-isuserinternal="true"
      >
        {productDescription.map(blockNode => (
          <BlockSkeleton key={blockNode.id} node={blockNode} />
        ))}
      </div>
    </>
  );
};

export const MainFormSkeleton = connectMainSkeletonForm(Component);
MainFormSkeleton.displayName = 'MainFormSkeleton';
